import { AxiosError } from 'axios';
import { useQuery } from 'react-query';
import { getMatchAuditLogs } from '../api/matchApi';

type UseAuditLogsResponse = {
  data: HistoryLogEntryResponse[],
  isLoading: boolean,
  isError: boolean,
  error: AxiosError | null,
  isFetching: boolean,
  refetch: () => void,
}

export const useHistoryLogsMatch = (
  accountId: string,
  positionId: string,
  matchId: string,
  onCallback: () => void,
):UseAuditLogsResponse => {
  const {
    data,
    isLoading,
    isError,
    isFetching,
    error,
    refetch,
  } = useQuery<HistoryLogResponse, AxiosError>(
    ['history', accountId, positionId, matchId],
    () => {
      return getMatchAuditLogs(accountId, positionId, matchId);
    }, {
      onSuccess: () => {
        onCallback();
      },
      enabled: !!accountId && !!positionId && !!matchId,
      retry: false,
    });

  return {
    data: data?.logs || [],
    isLoading,
    isError,
    error,
    isFetching,
    refetch,
  };
};
